<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 人员风险评估-半环形饼图
	export default {
		name: 'PersonRiskDonutChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true
			},
			title: {
				type: String,
				default: ''
			},
			// 是否显示图例
			showLegend: {
				type: Boolean,
				default: true
			},
			// 图例位置
			legendPosition: {
				type: String,
				default: 'right'
			},
			// 颜色列表
			colorList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					title: this.title
						? {
								text: this.title,
								left: 'center',
								top: 0,
								textStyle: {
									fontSize: 16,
									fontWeight: 'normal'
								}
						  }
						: null,
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: this.showLegend
						? {
								orient: 'horizontal',
								// right: this.legendPosition === 'right' ? 10 : null,
								// left: this.legendPosition === 'left' ? 10 : null,
								// top: 'center',
								bottom: '0',
								icon: 'circle',
								itemWidth: 10,
								itemHeight: 10,
								textStyle: {
									fontSize: 14
								}
						  }
						: null,
					color:
						this.colorList.length > 0
							? this.colorList
							: [
									'#33c355', // 绿色
									'#ff9733', // 橙色色
									'#f76565' // 红色
							  ],
					series: [
						{
							name: this.title || '风险评估',
							type: 'pie',
							radius: ['50%', '80%'], // 内外半径，形成环形
							center: ['50%', '50%'],
							startAngle: 360, // 起始角度设为360度，形成半环
							endAngle: 0, // 结束角度设为0度
							avoidLabelOverlap: true,
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							data: this.chartData
						},
						// 添加一个隐藏的半环，用于补全图形
						{
							name: '',
							type: 'pie',
							radius: ['50%', '80%'],
							center: ['50%', '50%'],
							startAngle: 0, // 从0度开始
							endAngle: -360, // 到-3600度结束
							silent: true, // 不响应鼠标事件
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							itemStyle: {
								color: 'rgba(0, 0, 0, 0.05)' // 灰色半透明
							},
							data: [{ value: 1, name: '' }]
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
